import {useParams} from "react-router-dom";
import {useState} from "react";
import classNames from 'classnames';

const CustomSwitch = ({type = 0, checked = false, onChange, label = '', disabled = false}) => {

    const handleClick = () => {
        if (disabled) return;
        if (onChange) onChange(!checked);
    };

    if (type === 0) {
        return (
            <div className='flex flex-col gap-y-3'>
                <span className="text-sm font-bold text-black">{label}</span>
                <button
                    type="button"
                    onClick={handleClick}
                    className={`flex items-center gap-3 select-none ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}>
                    <span className={`w-12 h-6 rounded-full p-1 transition-colors duration-200 ${checked ? 'bg-green-500' : 'bg-gray-300'}`}>
                        <span className={`block w-4 h-4 rounded-full bg-white shadow transform transition-transform duration-200 ${checked ? '-translate-x-6' : 'translate-x-0'}`} />
                    </span>
                </button>
            </div>
        );
    }
};

export default CustomSwitch;